export const defaultState = {
  id: null,
  holderId: null,
  title: '',
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  birthDate: null,
  status: '',
  levelId: null,
  issueDate: null,
  maId: null,
  certType: '',
  validUntil: null,
  certificateNumber: '',
  authorizedByHolder: false,
  visibility: false,
  organisation: null,
  certificationBodyId: null,
  selectedHolder: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    const newState = {
      ...state,
      ...action.payload,
      issueDate: action.payload.issueDate ? new Date(action.payload.issueDate) : undefined,
      validUntil: action.payload.validUntil ? new Date(action.payload.validUntil) : undefined,
      selectedHolder: action.payload.holderId
        ? {
            value: action.payload.holderId,
            label: `${action.payload.firstName} ${action.payload.lastName}`,
          }
        : null,
    };
    return newState;
  }
  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'issueDate') {
      const newValidUnitil = new Date(action.payload.value);
      newValidUnitil.setFullYear(newValidUnitil.getFullYear() + 5);
      newValidUnitil.setDate(newValidUnitil.getDate() - 1);
      return { ...state, [action.payload.name]: action.payload.value, validUntil: newValidUnitil };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
